module.exports = __webpack_public_path__ + "img/ytShorts_light.29fd5629.svg";